import React, { Component, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
        height:'100%',
        width:'100%'
    },
});
class AddCardView extends Component {
  componentDidUpdate() {
    let paymentForm = document.forms[this.props.form_id ? this.props.form_id : 'paymentForm'];
    //console.log("paymentForm:",paymentForm);
    if(paymentForm){
      paymentForm.submit()
    }
  }
    render() {
        const { classes, t, onCloseAddCard, html_content } = this.props

        // if(html_content){
        //   html_content = html_content.replace(`<div class="row">`,`<div>`)
        // }

        console.log("AAA html_content:",html_content);
        return (
            <div>
                <DrawerCustom
                    open={this.props.open}
                    onClose={() => onCloseAddCard()}
                    title={t('add_a_card')}
                    enableBack
                >
                    
                    {this.props.isOverwriteDocument ? document.write(html_content) : <div style={{width:'100%'}} dangerouslySetInnerHTML={{__html:html_content}}/>}
                    <Grid xs={12} item container justify='center'><CustomizedCircularProgress/></Grid>
                </DrawerCustom>
            </div>
        );
    }
}
export default withStyles(styles)(withTranslation()(AddCardView));